import { useMutation } from 'react-query'

import ProductService from 'src/services/product.service'

const useUpdateProductNfts = () => {
  return useMutation(
    async () => {
      return ProductService.updateProductNfts()
    },
    {
      onSuccess: (data) => {
        if (!data) return
      },
    },
  )
}

export { useUpdateProductNfts }
